export default __webpack_public_path__ + "static/aie-thumb-2b6d49d3a097dda7661c5420181e045e.png";